module.exports = __webpack_public_path__ + "img/trophy.bbd59bd5.png";